<template>
  <BasePageContainer class="page goal goal-add pt-5 pb-10">
    <div class="page__head edit-head fixed-top p-3">
      <h1 class="edit-head__heading">
        <img
          src="@/assets/images/icon_flag-w.svg"
          class="img-fluid edit-head__icon mr-2">
        ノートの編集
      </h1>
    </div>
    <GoalForm
      v-if="goal"
      ref="form"
      :goal-object="goal"
      :is-lock-goal="lockGoalOption"
      :non-field-error="nonFieldError"
      is-edit
      @onClickSave="saveGoal"
      @onClickDelete="deleteGoal" />
  </BasePageContainer>
</template>

<script>
import GoalForm from '@/components/view/GoalForm.vue'
import confirmIfFormChanged from '@/components/mixin/confirmIfFormChanged'
import startOfMonth from 'date-fns/startOfMonth'
import endOfMonth from 'date-fns/endOfMonth'
import format from 'date-fns/format'
export default {
  components: {
    GoalForm
  },
  mixins: [confirmIfFormChanged()],
  data() {
    return {
      localGoal: null,
      goal: null,
      nonFieldError: '',
      lockGoalOption: false
    }
  },
  computed: {
    memberId() {
      return this.$route.params.id
    },
    goalId() {
      return this.$route.params.goalId
    },
    hasRepeatGroup() {
      return this.goal.repeatGroup != null
    },
    willChangeRepeat() {
      return this.isRepeat !== this.hasRepeatGroup
    },
    willRepeatOff() {
      return this.willChangeRepeat && !this.isRepeat
    },
    isChangedRange() {
      return this.localGoal.startDate !== this.goal.startDate 
        || this.localGoal.endDate !== this.goal.endDate
    },
  },
  async created() {
    this.$store.commit('startLoading')
    await this.fetchAll().catch((err) => {
      console.error('err', err)
      this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
    })
    this.$store.commit('finishLoading')
  },
  methods: {
    setGoalRange(date) {
      const baseDate = new Date(date)
      const startDate = startOfMonth(baseDate)
      const endDate = endOfMonth(baseDate)
      this.localGoal = {...this.localGoal, startDate: format(startDate, 'yyyy-MM-dd'), endDate: format(endDate, 'yyyy-MM-dd')}
    },
    async fetchGoal() {
      const goal = await this.$axios.get(`/goals/${this.goalId}/`).then(res => res.data)
      this.goal = Object.assign({
        ...goal,
        conditionItems: goal.conditionSetting ? goal.conditionSetting.items : [],
        isRecordBodyPain: goal.bodyPainSetting ? goal.bodyPainSetting.isRecordBodyPain : false,
        createdUserName: goal.createdBy.name
      })
      this.isRepeat = this.goal.repeatGroup != null
      this.localGoal = Object.assign({}, this.goal)
    },
    async fetchLockGoalOption() {
      this.lockGoalOption = await this.$axios.get('/tenants/').then((res) => res.data.lockGoalOption)
    },
    fetchAll() {
      return Promise.all([this.fetchGoal(), this.fetchLockGoalOption()])
    },
    async saveGoal(patchBody, willRepeatOff) {
      this.$store.commit('startLoading')
      let isFailed = false

      if (willRepeatOff) {
        await this.$axios.post(`/goals/${this.goalId}/repeat_off/`).catch(() => {
          isFailed = true
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
        })
      }

      await this.$axios.patch(`/goals/${this.goalId}/`, patchBody)
        .catch((err) => {
          isFailed = true
          if (!err.response) {
            this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
            return
          }
          if (err.response.data.startDate || err.response.data.endDate) {
            this.nonFieldError = '実際に存在する日付を入力してください'
            return
          }
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
        })

      if (!isFailed) {
        this.canLeave = true
        this.$nextTick(() => {
          this.$router.push(`/members/${this.memberId}?goalId=${this.goalId}`)
        })
        this.$store.commit('notify/set', {message: 'ノートの編集が完了しました。'})
      }
      this.$store.commit('finishLoading')
    },
    async deleteGoal(hasRepeatGroup) {
      this.$store.commit('startLoading')
      let isFailed = false
      if (!window.confirm('ノートを削除してもよろしいですか?')) {
        this.$store.commit('finishLoading')
        return
      }

      if (hasRepeatGroup) {
        await this.$axios.post(`/goals/${this.goalId}/repeat_off/`).catch(() => {
          isFailed = true
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
        })
      }

      // リピートをoffにできていない場合は削除処理をさせない
      if (isFailed) return

      await this.$axios.delete(`/goals/${this.goalId}/`).catch(() => {
        isFailed = true
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })

      if (!isFailed) {
        this.canLeave = true
        this.$nextTick(() => {
          this.$router.replace(`/members/${this.memberId}`)
        })
        this.$store.commit('notify/set', {message: 'ノートを削除しました。'})
      }
      this.$store.commit('finishLoading')
    },
    onClickCancel() {
      this.$router.push(`/members/${this.memberId}`)
    },
    dateErrorMessage(v) {
      if (!v) return ''
      return v[0]
    },
  }
}
</script>

<style lang="scss" scoped>
.edit-head{
  background-color: $l-blue;
  @media screen and (min-width:992px) {
    width: calc(100% - 422px);
    right: 0;
    left: auto;
  }
  &__icon{
    height: 22px;
    width: auto;
  }
  &__heading{
    color: $white;
    font-size: $fs-lg;
    font-weight: bold;
  }
}

.goal-pin-btn {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background-color: $white;
  padding: 3px;
  text-align: center;
  &__icon {
    width: 20px;
    height: auto;
  }
}

.goal-lock-btn {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  padding: 3px;
  background-color: $white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &__icon {
    color: $grey11;
    &--locked {
      color: $black;
    }
  }
}

.repeat-btn {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background-color: $white;
  padding: 3px;
  text-align: center;
  &__icon {
    cursor: pointer;
    width: 20px;
    height: auto;
  }
}
</style>